/**
 * @file index.tsx
 *
 * @fileoverview Renders a full width Hero search banner.
 */
import React from 'react';
import { HeroSearchBannerBackgroundParagraph } from '~/jobiqo/types/types';
import { JobSearchForm } from '~/components/Form/SearchInputForm';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import styles from './heroSearchBannerBackground.module.scss';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { FormattedMessage } from 'react-intl';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import Link from '~/jobiqo/components/Link';
import NextLink from 'next/link';
import { TextAnimated } from '~/vcl/atoms/13-text/04-text-animated';

interface HeroSearchBannerBackgroundProps {
  row: HeroSearchBannerBackgroundParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const HeroSearchBannerBackground = ({
  row,
  maxContainerSize,
}: HeroSearchBannerBackgroundProps) => {
  return (
    <div
      className={styles.heroSearchBannerBackground}
      style={{
        backgroundImage: row.image ? `url(${row.image.url})` : undefined,
      }}
    >
      <Spacing
        paddingTop={[5, row.spacing ?? 12]}
        paddingBottom={[0, row.spacing ?? 10]}
      >
        <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
          <div className={styles.content}>
            <TextAnimated
              tag="h1"
              fontSize={[6, 8]}
              lineHeight={[6, 7]}
              rotatingSentences={row.rotatingWords ?? []}
            >
              {row.h1}{' '}
            </TextAnimated>
            <JobSearchForm />
            {row.links && (
              <FlexItems gap={4}>
                <FlexItem>
                  <Text
                    marginTop={0}
                    fontWeight="bold"
                    className="hero_search_banner_background_buttons_label"
                  >
                    <FormattedMessage
                      id="hero_search_banner_background_buttons_label"
                      defaultMessage="Most searched: "
                    />
                  </Text>
                </FlexItem>
                <FlexItem>
                  <FlexItems
                    gap={3}
                    className={`jd-lp-hero-search-banner-background-button-container`}
                  >
                    {row.links.map((item, key) => {
                      return (
                        item?.url && (
                          <Link asChild>
                            <LinkButton
                              key={key}
                              linkElement={NextLink}
                              buttonStyle={row.color as any}
                              className={`${styles.buttonPill} jd-lp-hero-search-banner-background-button`}
                              {...getFormattedPageLink(item.url)}
                            >
                              {item.text}
                            </LinkButton>
                          </Link>
                        )
                      );
                    })}
                  </FlexItems>
                </FlexItem>
              </FlexItems>
            )}
          </div>
        </Main>
      </Spacing>
    </div>
  );
};
export default HeroSearchBannerBackground;
